import { Button } from "antd";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useScheduleColors } from "../../hooks/useScheduleColors";
import {
    startOpenModal,
    startSetActiveSchedule,
} from "../../redux/actions/operators/AcademicSchedules";
import dayjs from "dayjs";
import { motion } from "framer-motion";
import { IconApp } from "@components/IconApp";

export const ScheduleTableByWeekDayCell = ({
    time,
    session,
    events,
    academic_group,
    name,
    asPeriod = false,
    compact = false,
}) => {
    const dispatch = useDispatch();

    const { tiny_name } = useSelector((state) => state.config);

    const { eventPropGetter } = useScheduleColors(
        session,
        events,
        academic_group
    );

    //* Obtener los colores de los horarios usando el customHook
    const { style = "" } = eventPropGetter(time.schedule);

    //* Abrir modal del horario
    const handleScheduleFormActive = (data) => {
        dispatch(startSetActiveSchedule({ ...data }));

        if (tiny_name === "EAD") {
            // dispatch(startOpenModal("EAD"));
            dispatch(startOpenModal(name));
        } else {
            dispatch(startOpenModal(name));
        }
    };

    const formatModuleName = (module) => {
        switch (module) {
            case "M1":
                return "Módulo 1";
            case "M2":
                return "Módulo 2";
            case "M3":
                return "Módulo 3";
            case "LG":
                return "Longitudinal";
            case "LG_TESIS":
                return "Longitudinal Tesis";
            default: {
                //* Validar si es un horario de bloque
                const blocks = [
                    { value: "has_ord_block1", label: "Bloque 1" },
                    { value: "has_ord_block2", label: "Bloque 2" },
                    { value: "has_ord_block3", label: "Bloque 3" },
                    { value: "has_ord_block4", label: "Bloque 4" },
                ];

                const currentBlock = blocks.find(
                    (block) => time?.schedule?.[block.value]
                );

                return currentBlock
                    ? currentBlock.label
                    : module || "Sin módulo";
            }
        }
    };

    const formatTime = (value) => {
        if (!value) return "N/A";

        if (typeof value === "string") {
            // Asumimos formato HH:mm:ss
            return value.slice(0, 5);
        }

        // Si es Date o algo parseable
        return dayjs(value).format("HH:mm");
    };

    const isOneDayPeriod = time.schedule._from === time.schedule._to;
    const not_viewed_follow_ups = time.schedule?.not_viewed_follow_ups || 0;
    const showClassroom = !compact && time?.schedule?.classroom?.name;

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                compact ? (
                    <></>
                ) : (
                    <Tooltip id="button-tooltip">Ver horario</Tooltip>
                )
            }
        >
            <Button
                id={time?.id}
                className={
                    compact ? "text-size-10" : "text-size-13 font-weight-bold"
                }
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    rowGap: compact ? "2px" : "4px",
                    textAlign: "center",
                    height: "auto",
                    padding: compact ? "4px 6px" : "8px 12px",
                    minWidth: compact ? "auto" : "150px",
                    ...style,
                }}
                onClick={
                    compact
                        ? () => {}
                        : () => handleScheduleFormActive(time?.schedule)
                }
                type="primary"
                ghost
            >
                {asPeriod ? (
                    <span className="d-block">
                        {formatModuleName(time?.schedule?.module)}

                        {not_viewed_follow_ups > 0 && (
                            <motion.span
                                className="d-inline-block"
                                style={{ width: "20px" }}
                                initial={{ scale: 2, rotate: 0 }}
                                animate={{
                                    scale: 1,
                                    rotate: [0, -15, 15, -10, 10, -5, 5, 0],
                                }}
                                transition={{
                                    scale: {
                                        duration: 0.5,
                                        ease: "easeOut",
                                    },
                                    rotate: {
                                        duration: 1,
                                        ease: "easeInOut",
                                        repeat: Infinity,
                                    },
                                }}
                            >
                                <IconApp
                                    color="rgba(255, 255, 0)"
                                    iconClassName="fas fa-bell text-size-14"
                                    description="Tienes nuevos seguimientos"
                                />
                            </motion.span>
                        )}
                    </span>
                ) : (
                    <span className="d-block">
                        {`${formatTime(time?.start)} a ${formatTime(
                            time?.end
                        )}`}
                    </span>
                )}

                {isOneDayPeriod && (
                    <span className="d-block">{time.schedule._from}</span>
                )}

                {showClassroom && (
                    <span className="d-block">
                        {time?.schedule?.classroom?.name}
                    </span>
                )}
            </Button>
        </OverlayTrigger>
    );
};
